export const CALCULATOR_ERRORS = {
  FIRST_STEP_ERROR: 'Pole wymagane!',
  SUBSCRIBE_ERROR: 'Uzupełnij pole email!',
  SUBSCRIBE_API_ERROR: 'Coś poszło nie tak, spróbuj ponownie!',
  API_ERROR: 'EMAIL_ALREADY_TAKEN',
  API_MESSAGE_SUCCESS: 'Email Sent',
  API_MESSAGE_ERROR: 'Error Occurred'
}
